import Buttons from "../../../../../../components/ui/button/Buttons";
import { useExportContractCoveredScopesReportMutation } from "../../../../../../app/services/contractAPI";
import { saveAs } from 'file-saver';
import { useEffect, useState } from "react";
import { format_Date } from "../../../../../../components/finalMolGrid/libs/formatDate";
import FormDatePickerFields from "../../../../../../components/finalForms/formFields/FormDatePickerField";
import FormCheckboxField from "../../../../../../components/finalForms/formFields/FormCheckBoxFields";
import PropTypes from "prop-types";

const CoveredScopes = (props) => {

  const [isAsOfDate, setIsAsOfDate] = useState(new Date());
  const [isCoveredSummery, setIsCoveredSummery] = useState(false);

  const [exportCoveredScopeList, {
    isLoading: isExporting,
    isSuccess: isAllExported,
    data: exportAllData
  }] = useExportContractCoveredScopesReportMutation();

  useEffect(() => {
    if (!isExporting && isAllExported && exportAllData) {
      const blob = new Blob([exportAllData]);
      saveAs(blob, `Contracts Covered Report${props.currentDate}.xlsx`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExporting, isAllExported, exportAllData]);

  const handalExportCovered = () => {
    const req = {
      pdtAsOfDate: format_Date(isAsOfDate),
      pbSummary: isCoveredSummery
    }
    exportCoveredScopeList(req);
  }

  const handleClear = () => {
    setIsAsOfDate("");
    setIsCoveredSummery(false);
  }

  return (
    <div className="row p-2">
      <div className="col-7">
        <FormDatePickerFields
          dataField="asOfDate"
          value={isAsOfDate}
          labelName="As Of Date"
          isRequired={true}
          type="date"
          name="Select As Of Date"
          onChange={(dataField, value) => setIsAsOfDate(value)}
        />
      </div>
      <div className="col-2 mt-1">
        <FormCheckboxField
          dataField="pbSummary"
          value={isCoveredSummery}
          labelName="Summary"
          isRequired={true}
          type="checkbox"
          name="Select Summary"
          onChange={(dataField, value) => setIsCoveredSummery(value)}
        />
      </div>

      <div className="d-flex justify-content-center button-submit mt-3 mb-2">
        <Buttons
          buttonText="Extract"
          buttonTypeClassName="btn blue-btn w-full"
          onClick={handalExportCovered}
        />
        <Buttons
          buttonText="Clear"
          buttonTypeClassName="btn secondary-btn ml-4"
          onClick={handleClear}
        />
      </div>
    </div>
  );
};

CoveredScopes.propTypes = {
  currentDate: PropTypes.string.isRequired,
}

export default CoveredScopes;
